<template>
  <v-btn tile :ripple="false" flat v-on:click.native="onContrastChange" :aria-label="$t('TOP_BAR.BUTTON.CONTRAST')">
    <v-icon>mdi-invert-colors</v-icon>
  </v-btn>
</template>

<script>
import Vue from "vue";
import i18n, { changeLocale, SUPPORTED_LANGUAGES } from "../i18n/i18n";

export default {
  name: "ContrastSwitch",
  props: {
    onContrastChange: Function
  }
};
</script>
